export const homeObjOne = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'KARE OSS',
    headline: 'Our Services',
    description:
      'We are here to Privatize the emerging technologies ',
    buttonLabel: 'Scroll Down to Explore',
    imgStart: '',
    img: require('../../images/services.png'),
    alt: 'Credit Card',
    start: ''
  };
  